import React, { useEffect, useState } from 'react';
import { useZooPassAppContext } from "../../Context/ZooPassAppContext";
import { IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext } from "../../Context/ZooPassAnswersContext";
import { StepTitleContent } from "../PanelContents/StepTitleContent";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import { RenewalHrSegment, RenewalLoadingSegment } from "../PanelContents/RenewalSupportingSegments";
import { FinalizingStepsButtonRowSegment, FinalizingStepsPanel } from "../PanelContents/FinalizingSupportingSegments";
import ZooPassFetch from "../../Utilities/ZooPassFetch";
import { ZooPassLocalStateDataFinalizeItemStateStatus } from "../../Data/ZooPassLocalStateData";
import sprintf from "sprintf-js";
import ZooPassStepDataUtility from '../../Utilities/ZooPassStepDataUtility';
import useMembership from '../../Hooks/useMembership';

let debounceTimer: NodeJS.Timeout;

let interval: NodeJS.Timeout

export const Step9Panel: React.FC = () => {

    let {
        dictionary,
        textTitles,
        numericValues,
        loading,
        memberShipDetails,
        updateAppContext
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();

    const { getMemberInfo } = useMembership();
    const [redirected, setRedirected] = useState(false);

    // 0 show spinner
    // 1 show login
    // 2 show redirect
    const [loginRedirectState, setLoginRedirectState] = useState<0 | 1 | 2>(0);

    useEffect(() => {
        var redirect = localStorage.getItem("sessionRedirect");
        if (memberShipDetails?.isLoggedIn == true && redirect == "true") {
            localStorage.setItem("sessionRedirect", "false");
            if (debounceTimer) {
                clearTimeout(debounceTimer);
            }
            debounceTimer = setTimeout(onRedirectClick, 150);
        } else if (memberShipDetails?.isLoggedIn === false) {
            setLoginRedirectState(1);
        }
    }, [memberShipDetails?.isLoggedIn, answersData]);

    const onSessionRedirectClick = () => {
        if (answersData != null) {
            localStorage.setItem("sessionRedirect", "true");
            ZooPassLocalStateUtility.SetLocalState(answersData);
            ZooPassFetch.redirectTNewSession(window.baseApiUrl);
        }
    }

    const onRedirectClick = () => {
        if (answersData != null && answersData.finalizing != null) {
            triggerUpdateToChildren(answersData.step4FinalValue ?? 0).then(success => {

                if (success) {
                    const id = success.step1Value == 0 ? success.finalizing?.memberLevelNo ?? null : success.step8IdValue;
                    if(!id) {
                        console.error("ID is not available for redirection");
                        answersData.finalizing = {
                            initializing: null,
                            getChildrenSelection: answersData.finalizing?.getChildrenSelection || null,
                            login: answersData.finalizing?.login || null,
                            setChildren: answersData.finalizing?.setChildren || null,
                            redirecting: {
                                label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Redirecting"),
                                description: "ID is not available for adding to cart.",
                                status: ZooPassLocalStateDataFinalizeItemStateStatus.Failed
                            }
                        };
                        ZooPassLocalStateUtility.SetLocalState(answersData);
                        updateContext({ type: "setAnswers", value: answersData });
                        return;
                    }
                    const urlString = success.step1Value == 0 ? "/m/2/": "/donate/i/"; 
                    ZooPassLocalStateUtility.SetInitialState();   
                    interval = setInterval(function() {
                        var localState = ZooPassLocalStateUtility.ReadLocalState();
                        var currentStep = (localState?.step ?? 1);
                        if(currentStep == 1) {       
                            clearInterval(interval);            
                            localState && updateContext({"type": "setAnswers", "value": localState});
                            updateAppContext({type: "FETCH_INIT"})
                            window.location.href = window.tnewUrl + urlString + id;
                        }
                    }, 100);
                }
            });
        }
    }

    const showLoginButton = (setChildrenError?: string) => {
        if (answersData) {
            //Failed - show login button
            answersData.finalizing = {
                initializing: null,
                getChildrenSelection: answersData.finalizing?.getChildrenSelection || null,
                login: answersData.finalizing?.login || null,
                setChildren: {
                    label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:SetChildren"),
                    description: setChildrenError,
                    status: setChildrenError ? ZooPassLocalStateDataFinalizeItemStateStatus.Failed : ZooPassLocalStateDataFinalizeItemStateStatus.Unknown
                },
                redirecting: {
                    label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Redirecting"),
                    description: null,
                    status: ZooPassLocalStateDataFinalizeItemStateStatus.Failed
                }
            };
            ZooPassLocalStateUtility.SetLocalState(answersData);
            updateContext({ type: "setAnswers", value: answersData });
            setLoginRedirectState(2);
        }
    }

    const triggerUpdateToChildren = async (children: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9) => {
        if (answersData != null) {
            localStorage.setItem("sessionRedirect", "false");
            //Shouldn't be anything but ... just to make sure
            setLoginRedirectState(0);

            if (answersData.step1Value == 0 && answersData.formData){
                delete answersData.formData.giftPackageTo;
                delete answersData.formData.giftRenewalTo;
            }

            if(answersData.step3Value == 1 && answersData.formData){
                delete answersData.formData.adultFName2;
                delete answersData.formData.adultLName2;
            }

            let success = await ZooPassFetch.setMemberData(window.baseApiUrl, answersData.step8IdValue, {
                    memberID: answersData.formData?.memberID,
                    giftPackageTo: answersData.formData?.giftPackageTo,
                    giftRenewalTo: answersData.formData?.giftRenewalTo,
                    renewalYorN: answersData.step2Value == 1 ? "Yes" : "No",
                    children: children,
                    adultFName1: answersData.formData?.adultFName1,
                    adultLName1: answersData.formData?.adultLName1,
                    adultFName2: answersData.formData?.adultFName2,
                    adultLName2: answersData.formData?.adultLName2,
                    recipAddress: answersData.formData?.recipAddress,
                    recipCity: answersData.formData?.recipCity,
                    recipState: answersData.formData?.recipState,
                    recipPostal: answersData.formData?.recipPostal,
                    recipPhone: answersData.formData?.recipPhone,
                    recipEmail: answersData.formData?.recipEmail,
                    giftMessage: answersData.formData?.giftMessage,
                }).then((x)=> ({success: true, memberLevelNo: x.memberLevelNo, error: null})).catch((e) => ({success: false, error: e, memberLevelNo: null}));
            if (success.success) {
                //Success - display result - show redirect button
                answersData.finalizing = {
                    initializing: null,
                    getChildrenSelection: answersData.finalizing?.getChildrenSelection || null,
                    login: answersData.finalizing?.login || null,
                    setChildren: {
                        label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:SetChildren"),
                        description: null,
                        status: ZooPassLocalStateDataFinalizeItemStateStatus.Success
                    },
                    redirecting: {
                        label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Redirecting"),
                        description: null,
                        status: ZooPassLocalStateDataFinalizeItemStateStatus.Ready
                    },
                    memberLevelNo: success.memberLevelNo ?? null
                };
                ZooPassLocalStateUtility.SetLocalState(answersData);
                updateContext({ type: "setAnswers", value: answersData });
                setLoginRedirectState(0);
                return answersData;
            } else {
                showLoginButton(success.error);
            }
            //Run the fetch
            return {success: success.success
                , step8IdValue: answersData.step8IdValue
                , finalizing: answersData.finalizing
                , step1Value: answersData.step1Value
            };
        }
    }


    //Step Triggers
    const [triggerChildrenCheck, setTriggerChildren] = useState<number>(0);
    useEffect(() => {
        if (answersData != null && triggerChildrenCheck > 0) {
            //Initialize the finalization panel
            answersData.finalizing = {
                initializing: null,
                getChildrenSelection: {
                    label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:GetChildren"),
                    description: null,
                    status: ZooPassLocalStateDataFinalizeItemStateStatus.Current
                },
                login: null,
                setChildren: null,
                redirecting: null
            };
            ZooPassLocalStateUtility.SetLocalState(answersData);
            updateContext({ type: "setAnswers", value: answersData });

            const children = answersData?.step4FinalValue ?? 0;

            const valueFormat = numericValues.get("ZooPass:ProgressValue:04:Children");
            let updatedValue: string | null = "";
            if (valueFormat != null) {
                if (children === 0) {
                    updatedValue = valueFormat.format0;
                }
                if (children === 1) {
                    updatedValue = valueFormat.format1;
                }
                if (children > 1 && valueFormat.formatN !== null) {
                    updatedValue = sprintf.sprintf(valueFormat.formatN || "", answersData.step4FinalValue);
                }
            }

            // Allow for guest checkout without children if not a gift and not a renewal
            if (children === 0 && answersData.step1Value != 1 && answersData.step2Value != 1) {
                //Initialize the finalization panel
                answersData.finalizing = {
                    initializing: null,
                    getChildrenSelection: {
                        label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:GetChildren"),
                        description: updatedValue,
                        status: ZooPassLocalStateDataFinalizeItemStateStatus.Success
                    },
                    login: null,
                    setChildren: null,
                    redirecting: {
                        label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Redirecting"),
                        description: null,
                        status: ZooPassLocalStateDataFinalizeItemStateStatus.Ready
                    }
                };
                ZooPassLocalStateUtility.SetLocalState(answersData);
                updateContext({ type: "setAnswers", value: answersData });

                setTriggerChildren(0);
                setLoginRedirectState(2);
                return;
            } else {
                getMemberInfo()
                    .then(details => {
                        //Initialize the finalization panel
                        answersData.finalizing = {
                            initializing: null,
                            getChildrenSelection: {
                                label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:GetChildren"),
                                description: updatedValue,
                                status: ZooPassLocalStateDataFinalizeItemStateStatus.Success
                            },
                            login: {
                                label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Login"),
                                description: details.isLoggedIn ? "Logged In" : "Please Log In",
                                status: !details.isLoggedIn ? ZooPassLocalStateDataFinalizeItemStateStatus.Current : ZooPassLocalStateDataFinalizeItemStateStatus.Success
                            },
                            setChildren: null,
                            redirecting: {
                                label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Redirecting"),
                                description: null,
                                status: ZooPassLocalStateDataFinalizeItemStateStatus.Ready
                            }
                        };
                        ZooPassLocalStateUtility.SetLocalState(answersData);
                        updateContext({ type: "setAnswers", value: answersData });
                        setLoginRedirectState(details.isLoggedIn ? 2 : 1);
                    }).catch(error => {
                        console.log(error);
                        answersData.finalizing = {
                            initializing: answersData.finalizing?.initializing || null,
                            getChildrenSelection: {
                                label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:GetChildren"),
                                status: ZooPassLocalStateDataFinalizeItemStateStatus.Success
                            },
                            login: {
                                label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:Login"),
                                description: "Please Log In",
                                status: ZooPassLocalStateDataFinalizeItemStateStatus.Failed
                            },
                            setChildren: answersData.finalizing?.setChildren || null,
                            redirecting: answersData.finalizing?.redirecting || null
                        };
                        ZooPassLocalStateUtility.SetLocalState(answersData);
                        updateContext({ type: "setAnswers", value: answersData });
                        setLoginRedirectState(1);
                    });
            }
        }
    }, [triggerChildrenCheck]);

    //////////////////////////////////////////////////////////////////////////////
    //If newly arrived on this step, reset everything
    useEffect(() => {
        if (!answersLoading && answersData != null) {

            //Will have answers - do next check
            if (answersData.step == 9 && answersData.step != answersData?.previousStep) {
                setTriggerChildren(triggerChildrenCheck + 1);

                //Initialize Step Triggers
                //Initialize the finalization panel
                answersData.finalizing = {
                    initializing: null,
                    getChildrenSelection: {
                        label: dictionary.get("ZooPass:StepLayout:09:FinalizeItemLabel:GetChildren"),
                        description: null,
                        status: ZooPassLocalStateDataFinalizeItemStateStatus.Ready
                    },
                    login: null,
                    setChildren: null,
                    redirecting: null
                };
                ZooPassLocalStateUtility.SetLocalState(answersData);
                updateContext({ type: "setAnswers", value: answersData });
                setTriggerChildren(triggerChildrenCheck + 1);
            }
        }
    }, [answersLoading, answersData?.step, answersData?.previousStep]);

    const handleLoginClick = () => {
        ZooPassFetch.redirectTNewLogin(window.baseApiUrl);
    };

    return !answersLoading && !loading && answersData?.step == 9 && (
        <div className="container d-block">
            <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:09")} />
            {loginRedirectState == 0 && <RenewalLoadingSegment />}
            <FinalizingStepsPanel finalizingState={answersData.finalizing} />
            {loginRedirectState == 1 && <>
                <RenewalHrSegment />
                <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:09:Login")} />
                <FinalizingStepsButtonRowSegment
                    clickCallback={() => handleLoginClick()}
                    buttonTextDictionaryKey={"ZooPass:StepLayout:09:Finalization:LogIn:ButtonText"}
                    headingDictionaryKey={"ZooPass:StepLayout:09:Finalization:LogIn:Heading"} />
            </>}
            {loginRedirectState == 2 && <>
                <RenewalHrSegment />
                <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:09:Redirect")} />
                <FinalizingStepsButtonRowSegment
                    clickCallback={() => onSessionRedirectClick()}
                    buttonTextDictionaryKey={"ZooPass:StepLayout:09:Finalization:Redirect:ButtonText"} />
            </>}
        </div>
    ) || <></>;
};

